<template>
  <div>
    <v-card class="top-row py-2 px-3" elevation="2">
      <v-chip-group mandatory active-class="primary--text" :value="selectedSection">
        <v-chip
          v-for="section in sections"
          :key="section.id"
          class="mr-4"
          @click="onClickHandler(section)"
        >
          {{ section.title }}
        </v-chip>
      </v-chip-group>
      <div class="left">
        <v-btn size="large" color="primary" :to="{ name: 'ReportCreate' }"> Skapa rapport </v-btn>
      </div>
      <!-- <div class="level-2 mt-2"></div> -->
    </v-card>
    <v-card class="top-row py-2 px-3 mt-3" elevation="2">
      <!-- FILTERS -->
      <component :is="filterComponent" v-bind="filters" @change="onChangeFilter" />
      <v-text-field
        class="search-field mr-3"
        label="Sök efter rapport"
        prepend-inner-icon="mdi-magnify"
        clearable
        elevation="2"
        outlined
        hide-details="true"
        dense
        @input="onSearch"
      >
      </v-text-field>
    </v-card>
    <LatestReport class="mt-3" :loading="loading" :label="label" :items="reports">
      <template #pagination>
        <div class="pagination-container">
          <Pagination v-bind="meta" @change="onPagination" />
        </div>
      </template>
    </LatestReport>
    <router-view></router-view>
  </div>
</template>

<script>
import LatestReport from '../../components/reports/LatestReportsNew.vue'
import reportTypes, { reportTypeUrls, sections } from '@/assets/data/reportTypes'
import Pagination from '@/components/shared/Pagination.vue'
import FiltersAvhandlingar from '@/components/filters/FiltersAvhandlingar.vue'
import FiltersLansrapporter from '@/components/filters/FiltersLansrapporter.vue'
import FiltersOtherReports from '@/components/filters/FiltersOtherReports.vue'

let debounce = null

export default {
  name: 'ReportList',
  props: {
    reports: { type: Array, default: () => [] },
    loading: { type: Boolean, default: true },
    meta: { type: Object },
    filters: { type: Object },
  },
  components: {
    LatestReport,
    Pagination,
  },
  data() {
    return {
      sections,
    }
  },
  computed: {
    label() {
      return `Senaste ${this.sections[this.selectedSection].label}`
    },
    section() {
      return reportTypes[this.$route.params.section]
    },
    selectedSection() {
      return this.sections.findIndex((s) => s.name === this.section)
    },
    filterComponent() {
      switch (this.section) {
        case 'avhandling':
          return FiltersAvhandlingar
        case 'Lans_rapp':
          return FiltersLansrapporter
        case 'orap':
          return FiltersOtherReports
        default:
          return null
      }
    },
  },
  methods: {
    onSectionChange(i) {
      this.$emit('change:section', this.sections[i])
    },
    onSearch(val) {
      clearTimeout(debounce)
      debounce = setTimeout(() => {
        this.$emit('search', val)
      }, 600)
    },
    onClickHandler({ name }) {
      const section = reportTypeUrls[name]
      this.$router.replace({ name: 'ReportsList', params: { section } })
    },
    onPagination(val) {
      this.$emit('reports:pagination', val)
    },
    onChangeFilter(filter) {
      this.$emit('reports:filter', filter)
    },
  },
}
</script>

<style lang="less" scoped>
.top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    display: flex;
    align-items: center;
  }
}
.search-field {
  max-width: 200px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
}
</style>
